import { ResourceType, ResourceVariant } from './resource-types'

export type Arn = string
export type Tag = { tagName: string; tagValue: string | null; operator?: string }
export type TagList = Array<Tag>

export interface MatchingRuleInfo {
  value: string | null
  operator: string
}

export enum SelectionMatchType {
  NO_MATCH = 0,
  ARN_MATCH = 1,
  TAG_MATCH = 2,
  TRANSITIVE_MATCH = 4,
  WEAK_TRANSITIVE_MATCH = 8,
  DIRECT_DEPENDEE_MATCH = 16,
}

export interface SelectableResource {
  /**
   * Defines the fields required for a resource to be evaluated by selection rules.
   * Derived interfaces exist for UI scenarios where additional fields are required.
   * Look for UserSelectableResource as an example.
   */
  resourceArn: Arn
  resourceId: string
  resourceName: string
  resourceType: ResourceType
  resourceVariant: ResourceVariant
  tags: Map<string, string>
  parentArn?: string
  descendantCount: number
  isContainer: boolean
  dependees: Array<string>
  weakDependees: Array<string>
  directDependees: Array<string>
  resourceGroup?: string
  selectionType: SelectionMatchType

  // The below fields are mutated in place during the rule matching process.
  arnMatch?: boolean
  matchingRules?: Map<string, MatchingRuleInfo>
  dependeeOf?: Set<string>
  weakDependeeOf?: Set<string>
  suppressedWeakDependeeOf?: Set<string>
  directDependeeOf?: Set<string>
  isExcluded?: boolean
}
